import React from 'react';
import EditForm from '../../../../components/Experiences/Form/EditForm';

const ExperienceEditFormPage = () => {
    return <EditForm />;
};

export default ExperienceEditFormPage;
